// "Connect to Clio" splash shown when the user isn't authenticated.
// No state, no fetches — just a styled card with a link to /auth/login
// (which redirects to Clio's OAuth authorize endpoint).

import React from "react";
import { C } from "../constants.js";

export function LoginPage({ currentFirm }) {
  // Split display_name on " & " so law-firm names with an ampersand
  // render as two lines (matches the sidebar treatment). Firms
  // without an "&" render as a single line.
  const displayName = currentFirm?.display_name || "";
  let brandLine1 = displayName, brandLine2 = "";
  const ampIdx = displayName.indexOf(" & ");
  if (ampIdx > 0) {
    brandLine1 = displayName.slice(0, ampIdx);
    brandLine2 = displayName.slice(ampIdx + 1);
  }

  return React.createElement("div", {
    style: {
      minHeight:"100vh", display:"flex", alignItems:"center", justifyContent:"center",
      background: `linear-gradient(135deg, ${C.navy} 0%, ${C.navyDark} 100%)`,
    }
  },
    React.createElement("div", {
      style: {
        background:"#fff", borderRadius:"16px", padding:"48px", maxWidth:"420px",
        width:"100%", textAlign:"center", boxShadow:"0 20px 60px rgba(0,0,0,0.3)",
      }
    },
      React.createElement("div", {
        style: { fontFamily:"'Playfair Display',serif", fontSize:"22px", fontWeight:700, color:C.navy, marginBottom:"4px" }
      }, brandLine1.replace(/,?\s*&$/, "")),
      brandLine2 && React.createElement("div", {
        style: { fontFamily:"'Playfair Display',serif", fontSize:"22px", fontWeight:700, color:C.navy, marginBottom:"8px" }
      },
        React.createElement("span", { style: { color: C.gold } }, "& "),
        brandLine2.replace(/^&\s*/, ""),
      ),
      React.createElement("div", {
        style: { fontSize:"12px", color:C.gold, letterSpacing:"0.1em", textTransform:"uppercase", fontWeight:600, marginBottom:"32px" }
      }, "Document Automation Agent"),
      React.createElement("p", {
        style: { fontSize:"15px", color:C.textMuted, marginBottom:"28px", lineHeight:1.6 }
      }, "Connect your Clio account to access the document automation dashboard."),
      React.createElement("a", {
        href: "/auth/login",
        style: {
          display:"inline-block", padding:"14px 32px", background:C.navy,
          color:"#fff", textDecoration:"none", borderRadius:"10px",
          fontWeight:600, fontSize:"15px", transition:"all 0.2s",
        },
        onMouseEnter: e => { e.target.style.background = C.navyLight; },
        onMouseLeave: e => { e.target.style.background = C.navy; },
      }, "Connect to Clio"),

      // Escape hatch, deliberately quiet. Clio's authorize page is
      // currently refusing the redirect back here with a form-action
      // CSP, which makes sign-in appear to stall after "Allow access".
      // The authorisation still succeeds, so /auth/manual accepts the
      // blocked address and completes the exchange by hand.
      //
      // Worded for the person who has just watched the page hang,
      // because that is the only circumstance in which it should be
      // clicked — and it should be removed once Clio fixes the header.
      React.createElement("p", {
        style: { marginTop: "22px", fontSize: "12px", color: C.textMuted,
                 maxWidth: "330px", marginLeft: "auto", marginRight: "auto",
                 lineHeight: 1.5 },
      },
        "Sign-in stalls after \u201cAllow access\u201d? Clio is currently "
        + "blocking the last step. ",
        React.createElement("a", {
          href: "/auth/manual",
          style: { color: C.navy, fontWeight: 600 },
        }, "Finish signing in here"),
        ".",
      ),

      React.createElement("p", {
        style: { marginTop:"32px", fontSize:"12px", color:C.textLight }
      }, "Charpen Consulting · v0.1.0"),
    )
  );
}
